/**
 * API endpoint for public programs list.
 */
export const PROGRAMS_API = "/programs/";

/**
 * API endpoint for authenticated user's programs.
 * For detail, append program ID: `/programs/user/{id}/`
 */
export const USER_PROGRAMS_API = "/programs/user/";

/**
 * Default page size for programs list.
 */
export const PROGRAMS_PAGE_SIZE = 20;

/**
 * Program role slugs matching backend ProgramRole.slug values.
 */
export const PROGRAM_ROLE_SLUG = {
  ENROLLED_PARTICIPANT: "enrolled_participant",
  PROSPECTIVE_PARTICIPANT: "prospective_participant",
  ORG_ADMIN: "org_admin",
  ORG_ONBOARDER: "org_onboarder",
  SOFT_INVITE_ORG_ADMIN: "soft_invite_org_admin",
} as const;
